export default class BlogsGrid {

    constructor() {
        this.addEvents();
    }
    addEvents() {
        jQuery(document).ready(function($) {
            let paged = 1;
            let ajaxurl = '/wp-admin/admin-ajax.php';
            let debounceTimer;
            let loading = "<div class='blogs-loading'><span class='blogs-loading__text'>Loading...</span><div class='blogs-loading__ball'></div></div>"
            let cat_id = $('.blogs-grid__cards').data('cat-id');
            function loadBlogs(cat_id = '') {

                $('.blogs-grid__cards').html(loading)

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'load_blogs',
                        paged: paged,
                        search: $('#search-blogs').val(),
                        cat_id: cat_id,
                    },
                    success: function(response) {
                        $('.blogs-grid__cards').html(response);
                    }
                });
            }

            $('#search-blogs').on('input', function() {
                clearTimeout(debounceTimer);

                debounceTimer = setTimeout(function() {
                    paged = 1;
                    loadBlogs(cat_id);
                }, 500);

            });

            $(document).on('click', '.pagination-link:not(.disabled)', function(e) {
                paged = $(this).data('page');
                loadBlogs(cat_id);
            });

            $(document).on('click', '.active-filter__item', function() {
                $('#search-blogs').val('')
                loadBlogs(cat_id);
            });

            $(document).on('click', '.search-blogs-icon', function(e) {
                e.preventDefault();

                let siblingElement = $(this).siblings('.closed, .opened');
                siblingElement.toggleClass('opened closed');
            });

            $(document).on('click','.blogs-filter__button .button', function(e) {
                e.preventDefault();

                $('.blogs-grid__popup').toggleClass('opened-popup');

                if ($('.blogs-grid__popup').hasClass('opened-popup')) {
                    $('body').css('overflow', 'hidden');
                } else {
                    $('body').css('overflow', '');
                }
            })

            $(document).on('click', '.blogs-grid__popup', function(e) {
                e.preventDefault();

                if (!$(e.target).closest('.gform_wrapper').length) {
                    $(this).removeClass('opened-popup');

                    if ($('.blogs-grid__popup').hasClass('opened-popup')) {
                        $('body').css('overflow', 'hidden');
                    } else {
                        $('body').css('overflow', '');
                    }
                }
            });

            $(document).on('click', function(e) {
                if (!$(e.target).is('input') && !$(e.target).closest('.search-blogs-icon').length) {
                    $('.opened').removeClass('opened').addClass('closed');
                }
            });

            loadBlogs(cat_id);
        });
    }

}
